require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-sitecore-netlify-integration-sitelify.json") })
        }
      }, "path---posts-sitecore-netlify-integration-sitelify");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-sitecore-netlify-integration-sitelify!./.cache/json/posts-sitecore-netlify-integration-sitelify.json
// module id = 369
// module chunks = 231608221292675